import Api from '@/services/Api'

export default {
  getSeasons (params) {
    return Api().get('/static/fake/seasons.json?accommodation_id=' + params.query)
  },
  getSpecials (params) {
    return Api().get('/static/fake/specials.json?accommodation_id=' + params.query)
  },
  getNights (params) {
    return Api().get('/static/fake/nights.json?accommodation_id=' + params.query)
  },
  getCancelations (params) {
    return Api().get('/static/fake/cancelations.json?accommodation_id=' + params.query)
  },
  getTaxes (params) {
    return Api().get('/static/fake/taxes.json?accommodation_id=' + params.query)
  },
  getCheckIn (params) {
    return Api().get('/static/fake/checkin.json?accommodation_id=' + params.query)
  },
  getCheckOut (params) {
    return Api().get('/static/fake/checkout.json?accommodation_id=' + params.query)
  },
  getLedgers (params) {
    return Api().get('/static/fake/ledgers.json?accommodation_id=' + params.query)
  },
  getRooms (params) {
    return Api().get('/static/fake/rooms.json?accommodation_id=' + params.query)
  },
  getPriceType (params) {
    return Api().get('/static/fake/price_types.json?accommodation_id=' + params.query)
  }
}



// WEBPACK FOOTER //
// ./src/services/Services.js